module.exports = __webpack_public_path__ + "static/media/loader-transparent.8b2a4cb5.svg";